<template>
  <div v-if="refinementSearchForm.filters.length > 0">
    <div class="sm-filter">
        <div data-interaction-refine-toggle class="refine-button" v-on:click="toggleRefinement"><i class="bss-icon-refine"></i>Filters</div>
        <div class="mobile-sort ico-bg bss-icon-chevron-thin-down">
          <select v-on:change="updateSearchResultSorting" v-model="optionSelected">
            <option :selected="optionSelected === 'relevance'" value="relevance">Sort by relevance</option>
            <option :selected="optionSelected === 'title'" value="title" >Sort by name</option>
            <option :selected="optionSelected === 'date'" value="date" >Sort by date</option>
          </select>
        </div>
    </div>
    <form v-bind:action="refinementSearchForm.pageUrl" method="get"  v-bind:class="mobileRefinement" id="refinement-filters">
      <div class="mobile-search-title">
        <h4 class="mobile-form-title">Refine search</h4>
        <span class="bss-icon-close close-mobile-form-icon" v-on:click="toggleRefinement"></span>
      </div>
      <div class="refinement-form__wrapper">
        <div v-for="(refinedFacet, index) in refinementSearchForm.filters.slice(0, totalFields)" :key="index" class="col-grid-layout">
          <TreeFacet
            v-model="refinementSearchForm.filters[index]"
            v-if="refinedFacet.template == 'tree.html' && refinedFacet.children.length > 0"
            v-on:input="updateFilter(refinementSearchForm.filters[index])" />
          <RangeFacet
            v-model="refinementSearchForm.filters[index]"
            v-if="refinedFacet.template == 'range.html'"
            v-on:input="updateFilter(refinementSearchForm.filters[index])" />
          <SelectFacet
            v-model="refinementSearchForm.filters[index]"
            v-if="isValidFacet(refinementSearchForm.filters[index])"
            v-on:input="updateFilter(refinementSearchForm.filters[index])" />
          <TextInputFacet
            v-model="refinementSearchForm.filters[index]"
            v-if="refinedFacet.template == 'text.html'"
            v-on:input="updateFilter(refinementSearchForm.filters[index])" />
        </div>
      </div>
      <!-- If we decide to not show all fields
      <div class="show-refinement-form" id="show-refinement-btn" v-on:click="toggleForm" v-if="refinementSearchForm.filters.length > 4"><span class="refinement-form__btn-text">{{ refinementText }}</span><span v-bind:class="chevronIconClass"></span>
      </div> -->
      <div class="form-footer">
        <button type="reset" class="grey" @click="clearFilters()">CLEAR FILTERS</button>
        <button type="submit" class="primary">{{ buttonLabel }}</button>
      </div>
    </form>
  </div>
</template>

<script>
 import RefinementAPI from "../services/RefinementAPI";
 import RangeFacet from "./refinements/RangeFacet.vue";
 import TreeFacet from "./refinements/TreeFacet.vue";
 import TextInputFacet from "./refinements/TextInputFacet.vue";
 import SelectFacet from "./refinements/SelectFacet.vue";
 import RefinementSearchForm from "../models/RefinementSearchForm.js";
 import {valueOrSlug} from "../utils/functions.js";

 export default {
   data() {
     return {
       menu: {},
       loading: true,
       refinementSearchForm: new RefinementSearchForm(
         window.BSS.selectedFilter
       ),
       refinementShowing: false,
       refinementText: 'More Filters',
       chevronIconClass: ['bss-icon-chevron-down'],
       mobileRefinement: '',
       totalFields: 99, // show all fields
       optionSelected: ''
     };
   },

   components: {
     RangeFacet,
     SelectFacet,
     TextInputFacet,
     TreeFacet,
   },

   created() {
     this.setSearchOrderDropdown();
     this.refinementSearchForm.syncMenu();
   },

   methods: {
     setSearchOrderDropdown() {
       let url = new URL(window.location);
       let urlParam =  url.searchParams.get('sort') || 'relevance';
       this.optionSelected = urlParam;
     },

     goToResults(refinementSearchForm) {
       window.location = searchResults;
     },

     // There are 2 valid facets, and they must have at least 1 child
     isValidFacet(refinedFacet) {
       return ['select.html', 'link.html'].includes(refinedFacet.template)
           && refinedFacet.children.length > 0
     },

     // Update the model and resync the menu/json
     updateFilter(value){
       this.refinementSearchForm.updateValue(value).syncMenu()
     },

     toggleForm() {
       this.refinementShowing = !this.refinementShowing;
       if(this.refinementShowing) {
         this.refinementText = "Less Filters";
         // remove rotate-down class fron chevron
         this.chevronIconClass = this.chevronIconClass.filter(str => str != 'rotate-chevron-down');
         this.chevronIconClass.push('rotate-chevron-up');
         this.totalFields = this.refinementSearchForm.filters.length;
       } else {
         this.refinementText = "More Filters";
         // remove rotate-up class fron chevron
         this.chevronIconClass = this.chevronIconClass.filter(str => str != 'rotate-chevron-up');
         this.chevronIconClass.push('rotate-chevron-down');
         this.totalFields = 99; // show all fields
       }
     },

     toggleRefinement() {
       // Show all Filters on mobile
       this.totalFields = this.refinementSearchForm.filters.length;
       this.refinementShowing = !this.refinementShowing;
       if(this.refinementShowing) {
         this.mobileRefinement = 'refinement-form__show';
         document.body.classList.add('refinement-showing');
       } else {
         this.mobileRefinement = 'refinement-form__hide';
         document.body.classList.remove('refinement-showing');
       }
     },

     updateSearchResultSorting() {
       // Sort option selected from dropdown, update window.location
       let uri = window.location.href;
       let value = this.optionSelected

       // remove the hash part before operating on the uri
       var i = uri.indexOf('#');
       var hash = i === -1 ? ''  : uri.substr(i);
       uri = i === -1 ? uri : uri.substr(0, i);

       var re = new RegExp("([?&])" + "sort=.*?(&|$)", "i");
       var separator = uri.indexOf('?') !== -1 ? "&" : "?";
       if (uri.match(re)) {
         uri = uri.replace(re, '$1' + "sort=" + value + '$2');
       } else {
         uri = uri + separator + "sort=" + value;
       }
       window.location = uri + hash;  // finally append the hash as well
     },

     clearFilters() {
       this.refinementSearchForm.resetValues()
     }
   },

   computed: {
     buttonLabel() {
       return this.refinementSearchForm.total !== null
            ? `View ${this.refinementSearchForm.total} Results`
            : `Loading...`
     }
   },
 };
</script>
